import { PaymentApi, PaymentTypes } from '@kaltura-ott/ms-ott-clients';

import { getConfig, KuxConfig, KuXConfig } from './config';
import { KuXDms } from './dms';
import { PurchaseStates } from './subscriptions.helper';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let client: any = null;

export const paymentClientPost = (
  partnerId: number,
  data: PaymentTypes.PurchaseRequest,
): Promise<{
  state: PurchaseStates;
  code: string;
  paymentGatewayId: string;
  id: string;
}> => {
  const config: KuxConfig = getConfig(KuXConfig)('');

  if (!client) {
    // create instance of sso microservice client
    client = new PaymentApi.Api().api;
  }

  // create request params
  const dataRequest: PaymentTypes.PurchaseRequest = data;
  dataRequest.ks = config.ks;
  dataRequest.apiVersion = KuXDms.apiVersion;
  // post service action
  return client
    .paymentRouterPurchasePost(partnerId, dataRequest, {
      baseURL: config.endpointUrl,
    })
    .then(
      // @ts-expect-error TODO Fix
      ({ data }) => {
        return data;
      },
      // @ts-expect-error TODO Fix
      (data) => {
        const { code = '1' } = data.response?.data || {};
        return { code: code, state: PurchaseStates.error };
      },
    );
};
